import { DEFAULT_LOCALE, LOCALE_STORAGE_KEY, isAppLocale, type AppLocale } from './locales';

type LocaleReader = Pick<Storage, 'getItem'>;
type LocaleWriter = Pick<Storage, 'setItem'>;

function browserStorage(): Storage | undefined {
  if (typeof localStorage === 'undefined') {
    return undefined;
  }
  return localStorage;
}

export function readStoredLocale(
  storage: LocaleReader | undefined = browserStorage()
): AppLocale | null {
  if (!storage) {
    return null;
  }
  const stored = storage.getItem(LOCALE_STORAGE_KEY);
  if (!stored || !isAppLocale(stored)) {
    return null;
  }
  return stored;
}

export function resolveDisplayLocale(
  storage: LocaleReader | undefined = browserStorage()
): AppLocale {
  return readStoredLocale(storage) ?? DEFAULT_LOCALE;
}

export function persistDisplayLocale(
  locale: AppLocale,
  storage: LocaleWriter | undefined = browserStorage()
): void {
  storage?.setItem(LOCALE_STORAGE_KEY, locale);
}
